import { format, isValid, parseISO } from "date-fns";
import { es } from "date-fns/locale";

/** Normaliza valores de fecha de Postgres/Neon (Date, string ISO, timestamp). */
export function rowValueToIsoDate(v: unknown): string {
  if (v == null || v === "") return "";
  if (v instanceof Date) return v.toISOString().slice(0, 10);
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (isValid(d)) return d.toISOString().slice(0, 10);
  return "";
}

export function formatShortDay(dateRaw: unknown, fallback = "—"): string {
  const day = rowValueToIsoDate(dateRaw);
  if (!day) return fallback;
  const d = parseISO(`${day}T12:00:00`);
  if (!isValid(d)) return fallback;
  return format(d, "d/M", { locale: es });
}

export function formatDateTimeEs(
  dateRaw: unknown,
  pattern: string,
  fallback = "—",
): string {
  if (dateRaw == null || dateRaw === "") return fallback;
  const d =
    dateRaw instanceof Date
      ? dateRaw
      : parseISO(
          String(dateRaw).includes("T")
            ? String(dateRaw)
            : `${rowValueToIsoDate(dateRaw)}T12:00:00`,
        );
  if (!isValid(d)) return fallback;
  return format(d, pattern, { locale: es });
}

/** ISO-8601 completo para APIs (timestamps). */
export function rowValueToIsoDateTime(v: unknown): string {
  if (v == null || v === "") return "";
  if (v instanceof Date) return v.toISOString();
  const s = String(v).trim();
  if (!s) return "";
  const d = new Date(s);
  if (isValid(d)) return d.toISOString();
  return s;
}


/** Fecha calendario local YYYY-MM-DD (no UTC). Evita el salto de día con toISOString(). */
export function localCalendarDateIso(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Suma días sobre el calendario local y devuelve YYYY-MM-DD. */
export function addLocalCalendarDays(days: number, from: Date = new Date()): string {
  const x = new Date(from.getFullYear(), from.getMonth(), from.getDate() + days);
  return localCalendarDateIso(x);
}

/** Lista de N fechas calendario a partir de hoy (local). */
export function nextLocalCalendarDays(n: number, from: Date = new Date()): string[] {
  const out: string[] = [];
  for (let i = 0; i < n; i++) out.push(addLocalCalendarDays(i, from));
  return out;
}
